import { DOCUMENT } from '@angular/common';
import { inject, InjectionToken } from '@angular/core';


export interface RenderStyleHost {
  /** Target for @font-face stylesheet injection (Document or ShadowRoot). */
  styleRoot: Document | ShadowRoot;
  /** Target element for navigation-mode class mutations (e.g. 'mouse-navigate'). */
  classHost: HTMLElement;
}

/**
 * Injection token that abstracts the DOM targets used by RenderPageComponent for:
 *   - @font-face stylesheet injection → `styleRoot`
 *   - navigation-mode class mutations → `classHost`
 *
 * Default factory returns the global document and document.body, preserving
 * the pre-existing legacy/iframe behaviour when the token is not explicitly provided.
 *
 * Providers inside a Shadow DOM render host should override this token with the
 * shadow root and the render host element, so DOM side-effects are scoped to
 * the shadow boundary (AC-4).
 */
export const RENDER_STYLE_HOST = new InjectionToken<RenderStyleHost>('RENDER_STYLE_HOST', {
  factory: (): RenderStyleHost => {
    const document = inject(DOCUMENT);
    return {
      styleRoot: document,
      classHost: document.body
    };
  }
});
